export default {
    getSplashUrl(state) {
        return state.splashUrl;
    },
    homeData(state) {
        return state.homeData;
    },
    homeHash(state) {
        return state.homeHash;
    },
    gameTypes(state) {
        return state.gameTypes;
    },
    keyInput(state) {
        return state.keyInput;
    },
    focusedView(state) {
        return state.focusedView;
    },
    programList(state) {
        return state.programList;
    },
    programDetailInfo(state) {
        return state.programDetailInfo;
    },
    programDetailList(state) {
        return state.programDetailList;
    },
    themeDetailInfo(state) {
        return state.themeDetailInfo;
    },
    themeDetailList(state) {
        return state.themeDetailList;
    },
    leagueSeasonList(state) {
        return state.leagueSeasonList;
    },
    yearList(state) {
        return state.yearList;
    },
    roudnList(state) {
        return state.roudnList;
    },
    leagueVodList(state) {
        return state.leagueVodList;
    },
    topBannerInfo(state) {
        return state.topBannerInfo;
    },
    gameVodList(state) {
        return state.gameVodList;
    },
    systemPopup(state) {
        return state.systemPopup;
    },
    terms(state) {
        return state.terms;
    },
    uuid(state) {
        return state.uuid;
    },
    deviceId(state) {
        return state.deviceId;
    },
    userSubscription(state) {
        return state.userSubscription;
    },
    contentsPermission(state) {
        return state.contentsPermission;
    },
    services(state) {
        return state.services;
    },
    loginId(state) {
        return state.loginId;
    },
    userInfo(state) {
        return state.userInfo;
    },
    lambdaInfo(state) {
        return state.lambdaInfo;
    },
    vodData(state) {
        return state.vodData;
    },
    liveData(state) {
        return state.liveData;
    },
    playbackData(state) {
        return state.playbackData;
    },
    mouseActivated(state) {
        return state.mouseActivated;
    },
    packageVersion(state) {
        return state.packageVersion;
    }
}